// import components
import { Box, styled } from '@mui/material';
import Grid from '@mui/material/Grid';

// import types
import { ColorSquareProps } from './ColorPickerPopover.types';
import { Icon } from '@sdb/planning-ui';

export const ColorSquare = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color'
})<ColorSquareProps>(({ theme, color }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  background: color
    ? color
    : 'linear-gradient(to top left, #fff calc(50% - 1px), #dcdcdc , #fff calc(50% + 1px))'
}));

export const SvgIcon = styled(Icon)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  border: `1px solid transparent`
}));

export const StyledColorPickerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  gap: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledColorPickerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center'
}));
